<template>
  <div class="category-filter">
    <button
      v-for="category in categories"
      :key="category"
      class="category-chip"
      :class="{ active: modelValue === category }"
      @mousedown.prevent
      @click="$emit('update:modelValue', category)"
    >
      {{ category }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { CATEGORIES, type Category } from '@/data/projects';

defineProps<{
  modelValue: Category;
}>();

defineEmits<{
  (e: 'update:modelValue', value: Category): void;
}>();

const categories = CATEGORIES;
</script>

<style scoped>
.category-filter {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 2px 0;
}

.category-filter::-webkit-scrollbar {
  display: none;
}

.category-chip {
  flex-shrink: 0;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-surface);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.category-chip:hover {
  background: var(--hover-overlay);
  border-color: var(--text-secondary);
}

.category-chip.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: #000;
}
</style>
